class LiveClassTabs {
	static ALL = "All";
	static TODAY = "Today";
	static PAST = "Past";
    static UPCOMING = "Upcoming";
}

export { LiveClassTabs };